{
  "clear": "Cancella",
  "invalid": "(non valido)",
  "loading": "Caricamento...",
  "noResults": "Nessun risultato"
}
